import { Injectable } from '@angular/core'
import { catchError, Observable, of, shareReplay } from 'rxjs'
import { ApiService } from './api.service'
import { Channel } from '../store/interfaces/channel'

@Injectable({
  providedIn: 'root',
})
export class ChannelsService {
  private apiUrl = `channels`
  private cachedChannels$: Observable<Channel[]> | null = null
  private cachedAt = 0
  private readonly cacheTtlMs = 5 * 60 * 1000

  constructor(private apiService: ApiService) {}

  getChannels(forceRefresh = false): Observable<Channel[]> {
    const now = Date.now()
    if (!forceRefresh && this.cachedChannels$ && now - this.cachedAt < this.cacheTtlMs) {
      return this.cachedChannels$
    }

    this.cachedAt = now
    this.cachedChannels$ = this.apiService.get<Channel[]>(`${this.apiUrl}`).pipe(
      shareReplay({ bufferSize: 1, refCount: false }),
      catchError((err) => {
        this.cachedChannels$ = null
        this.cachedAt = 0
        console.error('Error cargando canales', err)
        return of([])
      }),
    )
    return this.cachedChannels$
  }
}
